import { differenceInCalendarDays } from 'date-fns';

import type { CompletedSegment } from '@/components/FlightSummary/Segment/resolver';
import type { Segment } from '@/generated/graphql';

interface UseCalculateTravelDaysProps {
  startSegment: Segment | CompletedSegment;
  endSegment: Segment | CompletedSegment;
}

type dateProp = number | Date;
interface CountDaysProps {
  from: dateProp;
  to: dateProp;
}

const countDays = ({ from, to }: CountDaysProps): number => {
  try {
    return differenceInCalendarDays(from, to);
  } catch {
    return 0;
  }
};

const calculateTravelDays: (props: UseCalculateTravelDaysProps) => number = ({
  startSegment,
  endSegment,
}) => {
  const startDate = new Date(startSegment.sections[0].departureDate);
  const endDate = new Date(endSegment.sections[0].departureDate);

  return countDays({ from: endDate, to: startDate });
};

export default calculateTravelDays;
